import { Route } from "react-router-dom";
import { SignInRedirectCallback, Logout, LogoutCallBack, SilentRenew } from "./components";

export const AuthenticationRoutes =
    [
        <Route key={0} exact={true} path="/signin-callback" component={SignInRedirectCallback} />,
        <Route key={1} exact={true} path="/logout" component={Logout} />,
        <Route key={2} exact={true} path="/logout/callback" component={LogoutCallBack} />,
        <Route key={3} exact={true} path="/silentrenew" component={SilentRenew} />
    ];